import styled from 'styled-components'

/**
 * I wanted to change the color of an SVG passed to <img />
 * See this: https://stackoverflow.com/a/43916743
 */
const ImageSVGMask = styled.div<{
  src: string
  color?: string
}>`
  background-color: ${({ theme, color }) => color ?? theme.colors.brandPrimary};
  mask: url(${({ src }) => src}) no-repeat center;

  img {
    opacity: 0;
  }
`

const ImageSVG = ({
  src,
  alt,
  color,
}: {
  src: string
  alt?: string
  color?: string
}) => {
  return (
    <ImageSVGMask src={src} color={color}>
      <img src={src} alt={alt} />
    </ImageSVGMask>
  )
}

export default ImageSVG
